/**
 * SectionCard — DeCarbonIQ Design System
 * Standard card container: white surface, slate-200 border, rounded-xl.
 *
 * Props:
 *   title      — card title (small text, semibold)
 *   subtitle   — optional subtitle below title
 *   action     — optional JSX in the top-right (e.g. a link/button)
 *   noPadding  — if true, body has no padding (for tables, full-bleed content)
 *   flush      — no padding on header either (rare)
 *   className  — extra outer classes
 *   bodyClass  — extra classes on the body div
 *   testid     — data-testid value
 *   children   — card body content
 */
import React from "react";

export function SectionCard({
  title,
  subtitle,
  action,
  noPadding = false,
  className = "",
  bodyClass = "",
  testid,
  children,
}) {
  const hasHeader = title || subtitle || action;

  return (
    <div
      className={`bg-white border border-slate-200 rounded-xl overflow-hidden ${className}`}
      data-testid={testid}
    >
      {hasHeader && (
        <div className="px-5 py-4 border-b border-slate-100 flex items-start justify-between gap-3">
          <div className="min-w-0">
            {title && (
              <h3 className="text-sm font-semibold text-slate-900 truncate">{title}</h3>
            )}
            {subtitle && (
              <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>
            )}
          </div>
          {action && (
            <div className="flex-shrink-0 text-xs text-[#059669] hover:opacity-80">
              {action}
            </div>
          )}
        </div>
      )}
      <div className={noPadding ? "" : `p-5 ${bodyClass}`}>
        {children}
      </div>
    </div>
  );
}

export default SectionCard;
